import PlannerAssignment from './PlannerAssignment';

export default PlannerAssignment;
